module.exports = __webpack_public_path__ + "static/media/provisioningcodeFull.65eb25cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/photos/provisioningcodeFull.png
// module id = 423
// module chunks = 0